import { useState, useEffect } from 'react';
import { getRetryMessage, subscribeRetryMessage } from 'utils/retryMessageStore';

/**
 * Hook que retorna a mensagem de retry atual do store global.
 * Quando o interceptor de retry chama setRetryMessage(), os componentes
 * que usam este hook re-renderizam e podem exibir a mensagem (ex.: no Loading).
 */
export function useRetryMessage(): string | null {
  const [message, setMessage] = useState<string | null>(() => getRetryMessage());

  useEffect(() => {
    return subscribeRetryMessage(setMessage);
  }, []);

  return message;
}
